import { useRef } from 'react'

import { useIntersectionObserver } from '@space-lib/hooks/useIntersectionObserver'
import { NotificationList } from '@space-shell/common/services/notifications'

import { useNotificationInfiniteRequest } from '../../hooks/useNotificationInfiniteRequest'
import NotificationCard from '../notificationCard'

const ADDITIONAL_FOR_PENULTIMATE_POSITION = 2

const NotificationList = () => {
  const { data, isLoading, isFetching, fetchNextPage, hasNextPage, isError } =
    useNotificationInfiniteRequest()

  const observer = useRef<IntersectionObserver>()

  const penultimateElementRef = useIntersectionObserver({
    observer,
    isLoading,
    isFetching,
    fetchNextPage,
    hasNextPage: Boolean(hasNextPage)
  })

  return (
    <>
      {data?.pages.map((page) =>
        page.notifications.map(({ content, time, read, metadata }, index) => {
          return (
            <NotificationCard
              key={metadata.traceId}
              description={content}
              timestamp={time}
              isRead={read}
              productName={metadata.productName}
              imageSrc={metadata.picture}
              url={metadata.url}
              membershipName={metadata.membershipName}
              type={metadata.type}
              userName={metadata.userName}
              ref={
                page.notifications.length === index + ADDITIONAL_FOR_PENULTIMATE_POSITION &&
                !isError
                  ? penultimateElementRef
                  : undefined
              }
            />
          )
        })
      )}
    </>
  )
}

export default NotificationList
